import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ProfileService {
    rootUrl = `${environment.apiUrl}/api/v1/`;
    constructor(private http: HttpClient) {}

    GetProfile() {
        const MethodName: string = 'profile?expand=country,balance,currency,allBalances,clients';
        const url: string = this.rootUrl + MethodName;
        return this.http.get(url);
    }
    GetCompanyLogo() {
        const MethodName: string = 'profile?expand=companyLogo,balance,clients';
        const url: string = this.rootUrl + MethodName;
        return this.http.get(url);
    }
    UpdateProfile(data:any) {
        const MethodName: string = 'profile';
        const url: string = this.rootUrl + MethodName;
        return this.http.put(url,data);
    }
    UpdateProfileSector(data:any,id:any) {
        const MethodName: string = 'clients/'+id;
        const url: string = this.rootUrl + MethodName;
        return this.http.put(url,data);
    }

    GetBalance() {
        const relativeUrl: string = 'user-all-balances';
        const url: string = this.rootUrl + relativeUrl;
        return this.http.get(url);
    }

    GetUserBalanceAffiliatePartner() {
        const relativeUrl: string = 'user-balances-affiliate-partner';
        const url: string = this.rootUrl + relativeUrl;
        return this.http.get(url);
    }

    GetUserBalance(roleId:string) {
        const relativeUrl: string = 'user-balances?role_id='+ roleId;
        const url: string = this.rootUrl + relativeUrl;
        return this.http.get(url);
    }

    UpdatePassword(data:any) {
        const MethodName: string = 'profile/update-password';
        const url: string = this.rootUrl + MethodName;
        return this.http.put(url,data);
    }

    AddRole(data:any) {
        const MethodName: string = 'profile/add-new-role';
        const url: string = this.rootUrl + MethodName;
        return this.http.put(url,data);
    }

    GetUserHasValidRole() {
        const MethodName: string = 'user-has-valid-role';
        const url: string = this.rootUrl + MethodName;
        return this.http.get(url);
    }
    
    headerLogo(file:any) {
        const relativeUrl: string = 'upload/company-logo-file-s3';
        const url: string = this.rootUrl + relativeUrl;
        const req = new HttpRequest('POST', url, file, {reportProgress: true,responseType: 'json',headers : new HttpHeaders({ 'Content-Type': 'multipart/form-data' })});
        return this.http.request(req);
    }

}
